import { matchIsValidTel } from 'mui-tel-input';
import * as Yup from 'yup';
import { isValidUPI } from '../library/shared';

export const gstCategoryOptions = [
  { label: 'Registered Business - Regular', id: 'RBR', text: 'Registered' },
  {
    label: 'Registered Business - Composition Scheme',
    text: 'Composition',
    id: 'RBCS',
  },
  { label: 'Unregistered Business', id: 'UB', text: 'Unregistered' },
  { label: 'Overseas Customer', id: 'OC', text: 'Overseas' },
  { label: 'SEZ (Special Economic Zone)', id: 'SEZ', text: 'SEZ' },
];
export function humanizeKey(key) {
  const parts = key
    .replace(/[_-]+/g, ' ') // snake/kebab -> space
    .replace(/([a-z\d])([A-Z])/g, '$1 $2') // camel -> space
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2') // ACRONYMThenWord -> split
    .split(' ');

  return parts
    .map((w) => {
      const lower = w.toLowerCase();
      // if (ACRONYMS[lower]) return ACRONYMS[lower];
      return lower.charAt(0).toUpperCase() + lower.slice(1);
    })
    .join(' ');
}

export const upiHandlesFormik = [
  { label: 'sbi', value: 'sbi' },
  { label: 'oksbi', value: 'oksbi' },
  { label: 'hdfcbank', value: 'hdfcbank' },
  { label: 'icici', value: 'icici' },
  { label: 'axisbank', value: 'axisbank' },
  { label: 'pnb', value: 'pnb' },
  { label: 'barodapay', value: 'barodapay' },
  { label: 'cnrb', value: 'cnrb' },
  { label: 'unionbankofindia', value: 'unionbankofindia' },
  { label: 'yesbank', value: 'yesbank' },
  { label: 'kotak', value: 'kotak' },
  { label: 'idfcfirstbank', value: 'idfcfirstbank' },
  { label: 'indus', value: 'indus' },
  { label: 'federal', value: 'federal' },
  { label: 'rbl', value: 'rbl' },
  // Note: Google Pay uses partner banks' handles
  { label: 'okhdfcbank', value: 'okhdfcbank' },
  { label: 'okicici', value: 'okicici' },
  { label: 'okaxis', value: 'okaxis' },
  // Note: PhonePe uses Yes Bank's handle
  { label: 'ybl', value: 'ybl' },
  { label: 'paytm', value: 'paytm' },
  // Note: Amazon Pay is usually associated with Axis Bank or ICICI Bank for UPI transactions
  { label: 'apl', value: 'apl' },
];

export const gstCategoryOptions1 = [
  { label: 'Registered Business - Regular', id: 'RBR', text: 'Registered' },
  {
    label: 'Registered Business - Composition Scheme',
    text: 'Composition',
    id: 'RBCS',
  },
  { label: 'Unregistered Business', id: 'UB', text: 'Unregistered' },
  { label: 'Overseas Supplier', id: 'OC', text: 'Overseas' },
  { label: 'SEZ (Special Economic Zone)', id: 'SEZ', text: 'SEZ' },
];

export const entityOptions = [
  {
    label: 'Artificial Juridical Person',
    id: 'ArtificialJuridicalPerson',
    panIdentifier: 'J',
  },
  { label: 'Association of Persons', id: 'AOP', panIdentifier: 'A' },
  { label: 'Body of Individuals', id: 'BOI', panIdentifier: 'B' },
  { label: 'Firm/Partnership', id: 'Firm', panIdentifier: 'F' },
  { label: 'Government', id: 'Government', panIdentifier: 'G' },
  { label: 'Hindu Undivided Family', id: 'HUF', panIdentifier: 'H' },
  { label: 'Individual', id: 'Individual', panIdentifier: 'P' },
  { label: 'Limited Liability Partnership', id: 'LLP', panIdentifier: 'E' },
  { label: 'Local Authority', id: 'LocalAuthority', panIdentifier: 'L' },
  { label: 'Trust', id: 'Trust', panIdentifier: 'T' },
  { label: 'Private Limited Company', id: 'PvtLtd', panIdentifier: 'C' },
  { label: 'Proprietorship', id: 'Proprietorship', panIdentifier: '' },
  { label: 'Public Limited Company', id: 'PublicLtd', panIdentifier: '' },
];

export const posOptions = [
  { label: 'Kerala', id: 'Kerala' },
  { label: 'Delhi', id: 'Delhi' },
  { label: 'Goa', id: 'Goa' },
];

export const underGroupOptions = [
  { label: 'Kerala', id: 'Kerala' },
  { label: 'Delhi', id: 'Delhi' },
  { label: 'Goa', id: 'Goa' },
];

export const billingCurrencyOptions = [
  { label: 'Rupee (₹)', id: '1' },
  { label: 'Dollar ($)', id: '2' },
  { label: 'Euro (€)', id: '3' },
];

export const countryOptions = [
  { label: 'India', id: 'in' },
  { label: 'USA', id: 'usa' },
  { label: 'Canada', id: 'ca' },
];

export const msmeOptions = [
  { label: 'Micro', id: 'micro' },
  { label: 'Small', id: 'small' },
  { label: 'Medium', id: 'medium' },
];

export const compositionScheme = [
  { option: '1% (For Traders and Manufacturers)', value: 1 },
  {
    option: '2% (For Manufacturers)',
    value: 2,
  },
  { option: '5% (For Restaurant sector)', value: 5 },
  { option: '6% (For Suppliers of Service or Mixed Suppliers)', value: 6 },
];

export const cashAccounts = [
  { label: 'Current A/c', id: 1 },
  { label: 'Overdraft A/c', id: 2 },
  { label: 'Cash Credit', id: 3 },
  { label: 'Savings A/c', id: 4 },
  { label: 'others', id: 5 },
];

export const initialValues = {
  gstCategory: '',
  gstin: '',
  pan: '',
  entity: '',
  pos: '',
  msme: '',
  TDSPercentage: '',
  TDSSection: '',
  legalName: '',
  legalShortName: '',
  email: '',
  foreignstate: '',
  foreigndistrict: '',
  foreignstateD: '',
  foreigndistrictD: '',
  creditLimit: '',
  creditPeriod: '',
  billingCurrency: '1',
  bankName: '',
  ifsc: '',
  branch: '',
  bankAC: '',
  cash: '',
  swiftcode: '',
  reg: '',
  Country: '',
  Pincode: '',
  State: '',
  District: '',
  City: '',
  billingAddress: '',
  CountryD: '',
  PincodeD: '',
  StateD: '',
  CityD: '',
  DistrictD: '',
  billingAddressD: '',
  ConsigneeName: '',
  ConsigneeGSTIN: '',
  fullname: '',
  Designation: '',
  // Mobile: '',
  // WhatsappContact: '',
  EmailContact: '',
  notes: '',
  upi: '',
  Comments: '',
};

export const gstin = Yup.string().matches(/\d{2}[A-Z]{5}\d{4}[A-Z]{1}\d{1}[Z]{1}[A-Z\d]{1}$/, 'GSTIN must be 15 characters long');

Yup.addMethod(Yup.string, 'isValidTel', function (errorMessage, opts = {}) {
  return this.test('isValidTel', errorMessage, function (value) {
    const { path, createError } = this;

    // Allow undefined/null/empty (use .required() outside if needed)
    // if (value == null || String(value).trim() === '') return true;

    const v = String(value).trim();

    // Allow just "+<digits>" (country code only, 1–4 digits accommodates most)
    // if (/^\+\d{1,4}$/.test(v)) return true;

    // Optionally pass defaultCountry etc. if you have it
    // e.g. opts = { defaultCountry: 'IN' }
    if (matchIsValidTel(v, opts)) return true;

    return createError({ path, message: errorMessage });
  });
});

export const validationSchema = (regType, gstincomp) =>
  Yup.object().shape({
    gstCategory: Yup.string().required('Please provide GST category'),
    // .when((gstCategory, schema) => {
    //   const isRequired = regType === 2 || regType === 4 ? true : false;
    //   return isRequired === true
    //     ? schema.required("Please provide Gst category.")
    //     : schema;
    // }),
    gstin: Yup.string()
      .max(15, 'Maximum 15 characters allowed')

      .when('gstCategory', (gstCategory, schema) => {
        const isRequired = (regType === 2 || regType === 4) && ['RBR', 'SEZ', 'RBCS'].includes(gstCategory[0]) ? true : false;
        return isRequired === true
          ? schema
              .required('GSTIN is required.')
              .matches(/\d{2}[A-Z]{5}\d{4}[A-Z\d]{2}[A-Z]{1}[A-Z\d]{1}$/, 'Invalid GSTIN')
              .test('is-unique-gstin', 'The party GSTIN cannot be the same as the company GSTIN', (value) => value !== gstincomp)
          : schema
              .matches(/\d{2}[A-Z]{5}\d{4}[A-Z\d]{2}[A-Z]{1}[A-Z\d]{1}$/, 'Invalid GSTIN')
              .test('is-unique-gstin', 'The party GSTIN cannot be the same as the company GSTIN', (value) => value !== gstincomp);
      }),
    pan: Yup.string().when('gstCategory', (gstCategory, schema) => {
      const isRequired = (regType === 2 || regType === 4) && ['RBR', 'SEZ', 'RBCS'].includes(gstCategory[0]) ? true : false;
      return gstCategory[0] === 'OC'
        ? schema
        : isRequired === true
        ? schema.required('Please Provide PAN').matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, 'Invalid PAN format')
        : schema.matches(/^[A-Z]{5}[0-9]{4}[A-Z]$/, 'Invalid PAN format');
    }),
    entity: Yup.string().when('gstCategory', (gstCategory, schema) => {
      const isRequired = (regType === 2 || regType === 4) && ['RBR', 'SEZ', 'RBCS'].includes(gstCategory[0]) ? true : false;
      return isRequired ? schema.required('Please Provide Legal Entity') : schema;
    }),
    pos: Yup.string().when('gstCategory', (gstCategory, schema) => {
      const isRequired = (regType === 2 || regType === 4) && ['RBR', 'SEZ', 'RBCS'].includes(gstCategory[0]) ? true : false;
      return isRequired ? schema.required('Please Provide Place of Supply') : schema;
    }),
    legalName: Yup.string()
      .matches(/[a-zA-Z]/, 'Invalid Legal Name')
      .required('Please provide Legal Name'),
    bankAC: Yup.string()
      .min(9, 'Account number must be at least 9 digits')
      .max(18, 'Account number must be at most 18 digits')
      .matches(/^\d+$/, 'Account number must contain only digits'),
    legalShortName: Yup.string()
      .matches(/[a-zA-Z]/, 'Invalid Ledger Name')
      .required('Please provide Ledger Name'),
    // .test("is-error", "Please provide Ledger Name", (value) => value !== ""),
    // .when("legalShortName", (legalShortName, schema) =>
    //   legalShortName ? schema.required() : schema
    // ),
    // .when("legalShortName", {
    //   is: (value) => !value || value.trim() === "",
    //   then: Yup.string().required("Please provide Ledger Name"),
    //   otherwise: Yup.string().notRequired(),
    // }),
    upi: Yup.string().test('isValidUpi', 'UPI is not valid', function (value) {
      if (!value) return true; // Skip validation if empty
      const upiCheck = isValidUPI(value);
      return upiCheck;
    }),
    billingCurrency: Yup.string().required('Please provide billing currency'),
    Country: Yup.string().when('pos', (pos, schema) => {
      const p = Array.isArray(pos) ? pos[0] : pos;
      return String(p) === '96' ? schema.required('Please provide Country') : schema;
    }),
    // CountryD: Yup.string().required('Please provide Country'),
    Pincode: Yup.string().length(6, '6 digits required'),
    // .required("Billing Address: Pincode to be entered"),
    // .required("Pincode to be entered"),
    PincodeD: Yup.string().length(6, '6 digits required'),
    // contactNumber: Yup.string().isValidTel("Invalid telephone number"),
    // Whatsapp: Yup.string().isValidTel("Invalid telephone number"),
    // contactNumber: Yup.string().isValidTel('Invalid telephone number'),
    // Whatsapp: Yup.string().isValidTel('Invalid telephone number'),
    // Mobile: Yup.string().isValidTel('Invalid telephone number'),
    // WhatsappContact: Yup.string().isValidTel('Invalid telephone number'),
    // .required("Delivery Address: Pincode to be entered"),
    // .required("Pincode to be entered"),
    ifsc: Yup.string().matches(/^[A-Za-z]{4}0[A-Za-z0-9]{6}$/, 'Invalid IFSC code'),
    swiftcode: Yup.string().matches(/^[A-Za-z]{4}[A-Za-z]{2}[A-Za-z0-9]{2}([A-Za-z0-9]{3})?$/, 'Invalid SWIFT/BIC code'),
    // bankAC: Yup.string().matches(/^\d{1,16}$/, "Invalid bank account number"),
    // State: Yup.string().required("Please provide Billing state"),
    // District: Yup.string().required("Please provide Billing district"),
    // City: Yup.string().required("Please provide Billing city"),
    billingAddress: Yup.string().when('pos', (pos, schema) => {
      const p = Array.isArray(pos) ? pos[0] : pos;
      return String(p) === '96' ? schema.required('Please provide billing address (Line 1)') : schema;
    }),
    // CountryD: Yup.string().required("Please provide Delivery Country"),
    // StateD: Yup.string().required("Please provide Delivery state"),
    // DistrictD: Yup.string().required("Please provide Delivery district"),
    // CityD: Yup.string().required("Please provide city"),
    // billingAddressD: Yup.string().required("Please provide Delivery address"),
    ConsigneeGSTIN: Yup.string()
      .max(15, 'Maximum 15 characters allowed')
      .matches(/\d{2}[A-Z]{5}\d{4}[A-Z\d]{2}[A-Z]{1}[A-Z\d]{1}$/, 'Invalid GSTIN'),

    EmailContact: Yup.string().matches(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, 'Invalid email'),
    email: Yup.string().matches(/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/, 'Invalid email'),
  });

export const initialStatus = {
  gstCategory: false,
  gstin: false,
  pan: false,
  entity: false,
  pos: false,
  legalName: false,
  legalShortName: false,

  Pincode: false,

  State: false,
  District: false,
  City: false,
  billingAddress: false,
  PincodeD: false,
  StateD: false,
  CityD: false,
  DistrictD: false,
  billingAddressD: false,
};

export const formikStatus = {
  gstCategory: true,
  gstin: true,
  pan: true,
  entity: true,
  pos: true,
  legalName: true,
  legalShortName: true,

  Pincode: true,
  State: true,
  District: true,
  City: true,
  billingAddress: true,
  PincodeD: true,
  StateD: true,
  CityD: true,
  DistrictD: true,
  billingAddressD: true,
};
